import styled from "styled-components";
import { THEME } from "../../styles/theme";

export const PageHeaderContainer = styled.div`
  display: flex;
  padding-top: 1rem;
  height: 5rem;
  gap: 1.25rem;
  background-color: ${THEME.palette.background.default};
  margin-bottom: -2rem;
`;
